import React from "react";
import { useUpgrade } from "../UpgradeContext";

/**
 * Reusable upgrade CTA. Renders a button that opens the global upgrade flow
 * via the UpgradeContext. The whole app should use this — when Stripe checkout
 * ships later we only change UpgradeContext.open(), nothing in this file.
 */
export default function UpgradeButton({
  feature,
  context = "",
  label = "Unlock with Navigator",
  variant = "clay", // 'clay' | 'ghost' | 'outline'
  size = "md",      // 'sm' | 'md' | 'lg'
  className = "",
  fullWidth = false,
  iconLeft = null,
  testid,
  onClick,
  ...rest
}) {
  const { open } = useUpgrade();

  const handle = (e) => {
    e?.stopPropagation?.();
    if (onClick) onClick(e);
    open(feature, context);
  };

  const sizeCls = size === "sm" ? "btn-sm" : size === "lg" ? "btn-lg" : "";
  const variantCls =
    variant === "ghost" ? "btn-ghost"
    : variant === "outline" ? "btn-outline"
    : "btn-clay";

  return (
    <button
      type="button"
      className={`btn ${variantCls} ${sizeCls} ${className}`.trim()}
      data-testid={testid || `upgrade-btn-${feature || "generic"}`}
      onClick={handle}
      style={fullWidth ? { width: "100%" } : undefined}
      {...rest}
    >
      {iconLeft}
      {label}
    </button>
  );
}
